export default __webpack_public_path__ + "static/media/FSKoopmanItalicVF.6f8760dd.woff2";